import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Button } from 'tea-component';
import classnames from 'classnames';
import NoData from '@gp/components/NoData';
import GeneralImageNew, { BACKGROUND_IMG_DEFAULT } from '@gp/components/GeneralImageNew';
import SwiperFullModal from '@gp/components/SwiperFullModal';
import GeneralModal from '@gp/components/GeneralModal';
import './index.scss';

export default function ElevatorPitch(props: any) {
  const { elevatorPitchData, getAdd, userIsAbleEdit, headTitle } = props;

  const [visibleImage, setVisibleImage] = useState(false);
  const [visibleIntroduction, setVisibleIntroduction] = useState(false);
  const introduction = elevatorPitchData?.introduction || '';
  const introductionContentRef = useRef<HTMLSpanElement>(null);
  const [isIntroductionOverflow, setIsIntroductionOverflow] = useState(false);

  useEffect(() => {
    const element = introductionContentRef.current;
    if (!element || !introduction) {
      setIsIntroductionOverflow(false);
      return;
    }

    const checkOverflow = () => {
      // Compare rendered height with full content height to detect > 5 lines.
      setIsIntroductionOverflow(element.scrollHeight - element.clientHeight > 1);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(() => {
      checkOverflow();
    });
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [introduction]);

  const imgListCur = useMemo(() => {
    return [elevatorPitchData.cover || ''];
  }, [elevatorPitchData]);

  const modalContent = useMemo(() => {
    return (
      <div className="dbg-elevator-pitch-introduction-modal-content">
        <div className="dbg-elevator-pitch-introduction-modal-content-text">
          {introduction || '-'}
        </div>
        {elevatorPitchData?.cover && (
          <img
            className="dbg-elevator-pitch-introduction-modal-content-image"
            src={elevatorPitchData.cover}
            alt="elevator-pitch-cover"
            referrerPolicy="no-referrer"
            onError={(e) => {
              const imageDom = e.currentTarget;
              imageDom.onerror = null;
              imageDom.src = BACKGROUND_IMG_DEFAULT;
            }}
            onClick={() => {
              setVisibleImage(true);
            }}
          />
        )}
      </div>
    );
  }, [introduction, elevatorPitchData?.cover]);

  // 关闭图片预览
  const handleCloseImagePreview = () => {
    setVisibleImage(false);
  };

  const isNoData = useMemo(() => {
    if (elevatorPitchData?.cloud_path !== '' || elevatorPitchData?.introduction !== '') {
      return false;
    }
    return true;
  }, [elevatorPitchData]);

  return (
    <>
      {!isNoData ? (
        <div
          className={classnames('dbg-project-detail-elevator-pitch-div', {
            'has-introduction': elevatorPitchData.introduction && !elevatorPitchData.cover,
            'has-cover': elevatorPitchData.cover && !elevatorPitchData.introduction,
          })}
        >
          {elevatorPitchData.introduction && (
            <div className="dbg-project-detail-elevator-pitch-div-text">
              <span
                ref={introductionContentRef}
                className="dbg-project-detail-elevator-pitch-div-text-content"
              >
                {introduction}
              </span>
              {isIntroductionOverflow && (
                <span
                  className="dbg-project-detail-elevator-pitch-div-text-more"
                  onClick={() => {
                    setVisibleIntroduction(true);
                  }}
                >
                  More
                </span>
              )}
            </div>
          )}
          {elevatorPitchData.cover && (
            <GeneralImageNew
              className="dbg-project-detail-elevator-pitch-div-new-image"
              domain={'game'}
              errorImg={BACKGROUND_IMG_DEFAULT}
              needBorderRadius={false}
              src={elevatorPitchData.cover || ''}
              onClick={() => {
                setVisibleImage(true);
              }}
            />
          )}
        </div>
      ) : (
        <NoData
          className="dbg-project-detail__body-game-pillar-nodata"
          text={
            userIsAbleEdit ? (
              <>
                Please click the Edit button on the right or directly{' '}
                <Button
                  type="link"
                  onClick={() => {
                    getAdd();
                  }}
                >
                  add Elevator Pitch.
                </Button>
              </>
            ) : (
              <>No Data</>
            )
          }
          height={240}
        />
      )}

      {visibleImage && (
        <SwiperFullModal
          visible={visibleImage}
          imageList={imgListCur}
          onClose={handleCloseImagePreview}
          headTitle={headTitle}
        />
      )}

      <GeneralModal
        className="gp-word-break-word dbg-elevator-pitch-introduction-modal"
        modalSize="m"
        visible={visibleIntroduction}
        title="Elevator Pitch"
        content={modalContent}
        isFooter={true}
        footerButtonGroup={['close']}
        onClose={() => {
          setVisibleIntroduction(false);
        }}
      />
    </>
  );
}
